
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoInfoTypeDateComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const childKey = this.getAttribute('data-child-key')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const recordIndex = this.getAttribute('data-record-index')

        let attributeItem
        if(recordIndex === null) {
            attributeItem = window.attributeItems[featureKey][featureInfoKey].attributeItems[key]
        } else {
            if(childKey) {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key][childKey]
            } else {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key]
            }
        }

        const template = document.createElement('template');

        template.innerHTML = '<span style="display:none;">' + attributeItem.ValueTimestamp + '</span>' + attributeItem.Prefix + attributeItem.Value + attributeItem.Suffix;


        initWebComponent(this, template )
    }
}

